"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disallowSlug = disallowSlug;
/**
 * disallowSlug()
 * Wraps your `getStaticProps()` function to prevent slugs from being used in the URL.
 * This allows us to build ISR pages with dynamic routes to avoid pre-generating them durin build time.
 * See https://nextjs.org/docs/pages/building-your-application/routing/dynamic-routes#optional-catch-all-segments
 *
 *
 * Pages are required to be defined as:
 * - [PAGE_NAME]
 *   - [[...slug]].page.tsx
 *
 * @example [[...slug]].page.tsx
 *
 * export async function getStaticPaths({}: GetStaticPathsContext) {
 *   return {
 *       paths: [],
 *       fallback: 'blocking',
 *   };
 * }
 *
 * export const getStaticProps = disallowSlug(async (context: GetStaticPropsContext) => {
 *    return {
 *       props: {...},
 *       revalidate: FOUR_HOURS,
 *    };
 * });
 *
 * @param getStaticPropsFn - The getStaticProps function for the page
 * @returns
 */
function disallowSlug(getStaticPropsFn) {
    return (context) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        // 404 any links with slugs
        // `params.slug` is expected when the page name is PAGENAME/[[...slug]].page.tsx.
        if ((_a = context.params) === null || _a === void 0 ? void 0 : _a.slug) {
            return {
                notFound: true,
            };
        }
        return yield getStaticPropsFn(context);
    });
}
//# sourceMappingURL=disallow-slug.js.map